import eq from "lodash-es/eq"

import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

import { EParticipantHoldsMode as EMode } from "./participant.hold.types"

const styles = {
    container: {
        container: (): string => "flex flex-col gap-y-[10px] items-center w-full @container",
        childContainer: (): string => "w-full"
    },
    hold: {
        container: ({ mode, isSelected }: { mode: EMode; isSelected: boolean }): string =>
            buildCssClassName(
                "[display:grid]",
                "grid-cols-[1fr]",
                "lg:grid-cols-[1fr_1fr]",
                "gap-[10px]",
                "lg:gap-[20px]",
                "pt-[15px]",
                "pr-[30px]",
                "pb-[20px]",
                "pl-[15px]",
                "lg:pl-[20px]",
                "rounded-[10px]",
                "border-[1px]",
                [eq(mode, EMode.Presentation) && "bg-white border-blue-500"],
                [
                    eq(mode, EMode.Selectable) && [
                        "cursor-pointer",
                        "relative",
                        "group",
                        "w-full",
                        "bg-white",
                        [isSelected ? "border-blue-200" : "border-blue-300"],
                        [isSelected ? "" : "min-[768px]:hover:bg-blue-600 min-[768px]:hover:border-blue-400"],
                        [isSelected ? "" : "focus-visible:bg-blue-600 focus-visible:border-blue-400"],
                        getTransitionTwClasses("all", 200)
                    ]
                ]
            ),
        mark: ({ isSelected }: { isSelected: boolean }): string =>
            buildCssClassName(
                "absolute",
                "top-[8px]",
                "right-[8px]",
                "rounded-full",
                "flex",
                "items-center",
                "justify-center",
                "w-[20px]",
                "h-[20px]",
                "bg-green-300",
                [isSelected ? "opacity-[1]" : "opacity-[0]"],
                [isSelected ? "" : "min-[768px]:group-hover:opacity-[1] group-focus-visible:opacity-[1]"],
                getTransitionTwClasses("all", 200)
            ),
        col: (): string => "flex flex-col gap-y-[8px]",
        colTitle: (): string => buildCssClassName(getTransitionTwClasses("colors", 200)),
        mainSessionContainer: ({ isSelected }: { isSelected: boolean }): string =>
            buildCssClassName(
                "py-[5px] px-[10px] bg-blue-500 rounded-[5px] w-fit",
                [isSelected ? "" : ["min-[768px]:group-hover:bg-blue-400 group-focus-visible:bg-blue-400"]],
                getTransitionTwClasses("all", 200)
            ),
        sessionSetContainer: (): string =>
            buildCssClassName(
                "lg:mb-[5px]",
                "[list-style-position:outside]",
                "[list-style-type:disc]",
                "pl-[20px]",
                "flex",
                "flex-col",
                "ld:gap-y-[6px]"
            )
    }
} as const

export { styles as participantHoldStyles }
